import { ANIMATION_TIME, DEFAULT_TIME } from '../../constants';

import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import TimeChunk from './blocks/TimeChunk/TimeChunk';

import s from './Timesheet.scss';

import _padStart from 'lodash/padStart';
import scrollIntoView from 'scroll-into-view';

const cx = cls.bind(s);
class Timesheet extends PureComponent {
  static propTypes = {
    selectedTime: PropTypes.string,
    minTime: PropTypes.string,
    maxTime: PropTypes.string,
    timesheet: PropTypes.array,
    noMinMax: PropTypes.bool,
  };

  static defaultProps = {
    minTime: '00:00',
    maxTime: '23:30',
    noMinMax: false,
    timesheet: undefined,
  };

  constructor(props, context) {
    super(props, context);

    this.timesheet = props.timesheet || this.createTimeSheet();
  }

  componentDidMount() {
    const targetComponent = this[`${this.props.selectedTime || DEFAULT_TIME}-ref`];
    const targetNode = findDOMNode(targetComponent);
    scrollIntoView(targetNode, {
      time: ANIMATION_TIME,
      validTarget: (target, parentsScrolled) => parentsScrolled < 1,
    });
  }

  createTimeSheet() {
    return Array.from(new Array(24)).reduce((acc, cur, h) => {
      const hour = _padStart(`${h}`, 2, '0');
      return acc.concat(`${hour}:00`, `${hour}:30`);
    }, []);
  }

  createRef = (time) => (node) => {
    this[`${time}-ref`] = node;
  };

  checkIfInRange(time) {
    const times = [time, this.props.minTime, this.props.maxTime];
    const [intTime, intMinTime, intMaxTime] = times.map((timestr) => +timestr.replace(/:/, ''));

    return intTime >= intMinTime && intTime <= intMaxTime;
  }

  getTimeChunks() {
    return this.timesheet.map((time) => {
      const { onTimeSelect, onTimeHover, selectedTime, noMinMax } = this.props;

      const isSelected = selectedTime === time;
      const isDisabled = !noMinMax && !this.checkIfInRange(time);

      return (
        <TimeChunk
          key={time}
          time={time}
          ref={this.createRef(time)}
          isSelected={isSelected}
          isDisabled={isDisabled}
          onTimeSelect={onTimeSelect}
          onTimeHover={onTimeHover}
        />
      );
    });
  }

  render() {
    return <ul className={cx('Timesheet')}>{this.getTimeChunks()}</ul>;
  }
}

export default Timesheet;
